import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem , Autocomplete} from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useStoreStore } from "../../../hooks/useStoreStore";
import { useBranchOfficeStore } from "../../../hooks/useBranchOfficeStore";
import { useUbigeoStore } from "../../../hooks/useUbigeoStore";

type Values = {
    id: number,
    code: string,
    name: string,
    description: string,
    address: string,
    idbranchoffice:number,
    idcountry: number,
    iddepartment: number,
    idprovince: number,
    iddistrict: number,
    idcompany: number,
    status: string,
}

const states = [
    {name: 'Activo', value: '1'},
    {name: 'Desactivo', value: '0'},
]

export const StoreModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, storeSelected, liststore, clearState } = props;

    const { getCountries, getDepartments, getProvinces, getDistricts } = useUbigeoStore();
    const { action, createStore, editStore } = useStoreStore();
    const { getBranchOffice } = useBranchOfficeStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);

    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [branchOfficeSelected, setBranchOfficeSelected] = useState<any>('');
    const [countries, setCountries] = useState<any>([]);
    const [countryselected, setCountrySelected] = useState<any>('');
    const [departments, setDepartments] = useState<any>([]);
    const [departmentselected, setDepartmentSelected] = useState<any>('');
    const [provinces, setProvinces] = useState<any>([]);
    const [provinceselected, setProvinceSelected] = useState<any>('');
    const [districts, setDistricts] = useState<any>([]);
    const [districtselected, setDistrictSelected] = useState<any>('');

    const [data, setData] = useState<Values>({
        id: storeSelected ? storeSelected.id :'',
        code: storeSelected ? storeSelected.code :'',
        name: storeSelected ? storeSelected.name :'',
        description: storeSelected ? storeSelected.description :'',
        address: storeSelected ? storeSelected.address :'',
        idbranchoffice: storeSelected ? storeSelected.idbranchoffice :'',
        idcountry: storeSelected ? storeSelected.idcountry :'',
        iddepartment: storeSelected ? storeSelected.iddepartment :'',
        idprovince: storeSelected ? storeSelected.idprovince :'',
        iddistrict: storeSelected ? storeSelected.iddistrict :'',
        idcompany: storeSelected ? storeSelected.idcompany :'',
        status: storeSelected ? storeSelected.status :'1',
    });

    useEffect(() => {
        getBranchOfficeApi()
        getCountriesApi()
    },[])

    useEffect(() => {
        if(storeSelected && branchOffices){
            setCustomBranchOffice(storeSelected.idbranchoffice, branchOffices)
        }
    },[storeSelected, branchOffices])

    useEffect(() => {
        if(storeSelected && countries){
            const idcountry = storeSelected?.idcountry
            setCustomCountry(idcountry, countries)
            getDepartmentsApi(idcountry)
        }
    },[storeSelected, countries])

    useEffect(() => {
        if(storeSelected && departments){
            const iddepartment = storeSelected?.iddepartment;
            setCustomDepartment(iddepartment, departments)
            getProvincesApi(iddepartment)
        }
    },[storeSelected, departments])

    useEffect(() => {
        if(storeSelected && provinces){
            const idprovince = storeSelected?.idprovince;
            setCustomProvince(idprovince, provinces)
            getDistrictsApi(idprovince)
        }
    },[storeSelected, provinces])

    useEffect(() => {
        if(storeSelected && districts){
            const iddistrict = storeSelected?.iddistrict;
            setCustomDistrict(iddistrict, districts)
        }
    },[storeSelected, districts])

    const getBranchOfficeApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getBranchOffice(search);
            if(!response){
                setBranchOffices([]);
                setLoadingdata(false);
                return false;
            }else{
                setBranchOffices(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getCountriesApi = async() => {
        try {
            setLoadingdata(true);
            const response = await getCountries();
            if(!response){
                setCountries([]);
                setLoadingdata(false);
                return false;
            }else{
                setCountries(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getDepartmentsApi = async(idcountry='') => {
        try {
            setLoadingdata(true);
            const response = await getDepartments('', idcountry);
            if(!response){
                setDepartments([]);
                setLoadingdata(false);
                return false;
            }else{
                setDepartments(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getProvincesApi = async(iddeparment='') => {
        try {
            setLoadingdata(true);
            const response = await getProvinces('', iddeparment);
            if(!response){
                setProvinces([]);
                setLoadingdata(false);
                return false;
            }else{
                setProvinces(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getDistrictsApi = async(idprovince='') => {
        try {
            setLoadingdata(true);
            const response = await getDistricts('', idprovince);
            if(!response){
                setDistricts([]);
                setLoadingdata(false);
                return false;
            }else{
                setDistricts(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const setCustomBranchOffice = (idbranchoffice, branchOffices) => {
        const data = branchOffices.find(branch => branch.id == idbranchoffice);
        return setBranchOfficeSelected(data);
    }
    const setCustomCountry = (idcountry, countries) => {
        const data = countries.find(country => country.id == idcountry);
        return setCountrySelected(data);
    }
    const setCustomDepartment = (iddepartment, departments) => {
        const data = departments.find(department => department.id == iddepartment);
        return setDepartmentSelected(data);
    }
    const setCustomProvince = (idprovince, provinces) => {
        const data = provinces.find(province => province.id == idprovince);
        return setProvinceSelected(data);
    }
    const setCustomDistrict = (iddistrict, districts) => {
        const data = districts.find(district => district.id == iddistrict);
        return setDistrictSelected(data);
    }

    const onBranchOfficeSelected = (sucursal, values) => {
        setCountrySelected({id: sucursal?.idcountry, name: sucursal?.country});
        setDepartmentSelected({id: sucursal?.iddepartment, name: sucursal?.department});
        setProvinceSelected({id: sucursal?.idprovince, name: sucursal?.province});
        setDistrictSelected({id: sucursal?.iddistrict, name: sucursal?.district});
        setData({...values, 
            idbranchoffice: sucursal?.id,
            idcountry: sucursal?.idcountry,
            iddepartment: sucursal?.iddepartment,
            idprovince: sucursal?.idprovince,
            iddistrict: sucursal?.iddistrict,
        });
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.code) errors.code = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.address) errors.address = "el campo es requerido";
        if(!values.idcountry) errors.idcountry = "el campo es requerido";
        if(!values.iddepartment) errors.iddepartment = "el campo es requerido";
        if(!values.idprovince) errors.idprovince = "el campo es requerido";
        if(!values.iddistrict) errors.iddistrict = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {

        // setLoading(true);
        
        const dataForm = {
            ...values,
            idbranchoffice: values.idbranchoffice || '',
            idcountry: values.idcountry || '',
            iddepartment: values.iddepartment || '',
            idprovince: values.idprovince || '',
            iddistrict: values.iddistrict || '',
        }

        if(storeSelected){
            const response:any = await editStore(storeSelected.id, dataForm);
            if(response){
                liststore && liststore();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createStore(dataForm);
            if(response){
                liststore && liststore();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar bodega' : (action == 'add' ? 'Nueva bodega' : 'Detalle de la bodega')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Código:</FormLabel>
                                            <TextField
                                                id="code"
                                                type="text" 
                                                name="code"
                                                fullWidth
                                                size="small"
                                                value={values.code}
                                                onChange={handleChange}
                                                error={errors.code && touched.code ? true : false}
                                                helperText={errors.code && touched.code ? errors.code : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Nombre de la bodega:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Sucursal:</FormLabel>
                                            <Autocomplete
                                                id="idbranchoffice"
                                                size="small"
                                                value={!!branchOfficeSelected ? branchOfficeSelected : null}
                                                options={branchOffices || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small" 
                                                        error={errors.idbranchoffice && touched.idbranchoffice ? true : false}
                                                        helperText={errors.idbranchoffice && touched.idbranchoffice ? errors.idbranchoffice : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setBranchOfficeSelected(newValue);
                                                    onBranchOfficeSelected(newValue, values);
                                                    setFieldValue('idbranchoffice', newValue ? newValue?.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <FormLabel>País:</FormLabel>
                                            <Autocomplete
                                                id="idcountry"
                                                size="small"
                                                value={!!countryselected ? countryselected : null}
                                                options={countries || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.idcountry && touched.idcountry ? true : false}
                                                        helperText={errors.idcountry && touched.idcountry ? errors.idcountry : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setCountrySelected(newValue)
                                                    setFieldValue('idcountry', newValue ? newValue.id : "");
                                                    if(newValue) getDepartmentsApi(newValue.id)

                                                    setDepartmentSelected("");
                                                    setProvinceSelected("");
                                                    setDistrictSelected("");
                                                }}
                                                readOnly={action == 'detail' || branchOfficeSelected}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Región:</FormLabel>
                                            <Autocomplete
                                                id="iddepartment"
                                                size="small"
                                                value={!!departmentselected ? departmentselected : null}
                                                options={departments || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.iddepartment && touched.iddepartment ? true : false}
                                                        helperText={errors.iddepartment && touched.iddepartment ? errors.iddepartment : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setDepartmentSelected(newValue)
                                                    setFieldValue('iddepartment', newValue ? newValue.id : "");
                                                    if(newValue) getProvincesApi(newValue.id)

                                                    setProvinceSelected("");
                                                    setDistrictSelected("");
                                                }}
                                                readOnly={action == 'detail' || branchOfficeSelected}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Provincia:</FormLabel>
                                            <Autocomplete
                                                id="idprovince"
                                                size="small"
                                                value={!!provinceselected ? provinceselected : null}
                                                options={provinces || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.idprovince && touched.idprovince ? true : false}
                                                        helperText={errors.idprovince && touched.idprovince ? errors.idprovince : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setProvinceSelected(newValue)
                                                    setFieldValue('idprovince', newValue ? newValue.id : "");
                                                    if(newValue) getDistrictsApi(newValue.id)

                                                    setDistrictSelected("");
                                                }}
                                                readOnly={action == 'detail' || branchOfficeSelected}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Comuna:</FormLabel>
                                            <Autocomplete
                                                id="iddistrict"
                                                size="small"
                                                value={!!districtselected ? districtselected : null}
                                                options={districts || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.iddistrict && touched.iddistrict ? true : false}
                                                        helperText={errors.iddistrict && touched.iddistrict ? errors.iddistrict : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setDistrictSelected(newValue)
                                                    setFieldValue('iddistrict', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail' || branchOfficeSelected}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Dirección:</FormLabel>
                                            <TextField
                                                id="address"
                                                type="text" 
                                                name="address"
                                                fullWidth
                                                size="small"
                                                value={values.address}
                                                onChange={handleChange}
                                                error={errors.address && touched.address ? true : false}
                                                helperText={errors.address && touched.address ? errors.address : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Estado:</FormLabel>
                                            <Select
                                                id="status"
                                                value={values.status}
                                                size="small"
                                                onChange={(event) => { 
                                                    setFieldValue("status", event.target.value);
                                                }}
                                                error={ errors.status && touched.status ? true : false }
                                                fullWidth
                                                inputProps={{ readOnly: action == 'detail' }}
                                            >
                                                {
                                                    states.map((state, i) => {
                                                        return <MenuItem key={i} value={state.value}>{state.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="description"
                                                type="text" 
                                                name="description"
                                                fullWidth
                                                size="small"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={errors.description && touched.description ? true : false}
                                                helperText={errors.description && touched.description ? errors.description : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}